// STYLE
import './_events-calendar.scss'

// LIBS
import React from 'react'
import axios from 'axios'

// HELPERS
import eventSchedule from '../../data/code/event-schedule.json'
import { prepareRaw } from '../../lib/util.js'

// COMPONENTS
import MetaData from '../../components/meta-data'
import EventCalendarForm from '../../components/event-calendar-form/index.js'
import EventCalendarItemList from '../../components/event-calendar-item-list/index.js'

const headerStyle = {
  background: 'url("https://images.ctfassets.net/k428n7s2pxlu/1lzictumvmwoMg82Oy2M4i/db5549017347046280ba58c94d38b415/calendar-header.jpg") center center no-repeat',
  backgroundSize: 'cover',
}

// INTERFACE
class EventCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule: prepareRaw(eventSchedule, 'event'),
      designateLocationState: null,
    };
  }

  componentDidMount() {
    axios.get('https://s3.us-west-2.amazonaws.com/static.codefellows.org/events/event_schedule.json?ts=' + Date.now())
      .then(result => {
        if (result.data && result.data.events && result.data.events.length) {
          this.setState({
            schedule: prepareRaw(result.data, 'event'),
            designateLocationState: result.data.designateLocation
          });
        }
      })
      .catch((err) => console.error('errrrr', err));
  }

  render() {

    return (
      <div className="custom_pages events-calendar">
        <MetaData data={{
          slug: 'events-calendar',
          title: 'Demo Days & Info Sessions | Code Fellows',
          description: 'Code Fellows event calendar',
          }} />
        <header className="custom-page-header" style={headerStyle}>
          <h1>Events</h1>
        </header>
        <div style={{paddingTop: '1.5em'}} className="container">
          <div className="calendar">
          <EventCalendarItemList events={this.state.schedule}/>
           </div>
          <div className="calendar">
            <EventCalendarForm />
          </div>
        </div>
      </div>
    )
  }
}

export default EventCalendar


// WEBPACK FOOTER //
// ./src/pages/events-calendar/index.js